import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { MapPin, Mail, Phone, Clock } from "lucide-react";

export default function Footer() {
  const { settings } = useSite();
  const s = settings || {};
  return (
    <footer className="grain mt-24 bg-charcoal text-zinc-300">
      <div className="container-x grid gap-10 py-16 md:grid-cols-4">
        <div className="md:col-span-1">
          <span className="font-heading text-xl font-black tracking-tighter text-white">
            EAZY<span className="text-[#00E676]">CAR</span>TRACK
          </span>
          <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500">
            PHV Private Hire Rental
          </span>
          <p className="mt-4 text-sm leading-relaxed text-zinc-400">
            {s.homepage_subtext ||
              "Manchester private hire vehicles available for flexible weekly rental. Rent with or without insurance."}
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Rentals</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link className="hover:text-white" to="/cars">Available Cars</Link></li>
            <li><Link className="hover:text-white" to="/taxi-rental-manchester">Taxi Rental Manchester</Link></li>
            <li><Link className="hover:text-white" to="/private-hire-car-rental-manchester">Private Hire Car Rental</Link></li>
            <li><Link className="hover:text-white" to="/hybrid-taxi-rental-manchester">Hybrid Taxi Rental</Link></li>
            <li><Link className="hover:text-white" to="/uber-car-rental-manchester">For Uber Drivers</Link></li>
            <li><Link className="hover:text-white" to="/bolt-car-rental-manchester">For Bolt Drivers</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Driver Info</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link className="hover:text-white" to="/guides">Driver Guides</Link></li>
            <li><Link className="hover:text-white" to="/taxi-rental-with-insurance-manchester">Rental With Insurance</Link></li>
            <li><Link className="hover:text-white" to="/taxi-rental-without-insurance-manchester">Rental Without Insurance</Link></li>
            <li><Link className="hover:text-white" to="/faq">FAQs</Link></li>
            <li><Link className="hover:text-white" to="/rental-terms">Rental Terms</Link></li>
            <li><Link className="hover:text-white" to="/terms">Terms</Link></li>
            <li><Link className="hover:text-white" to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link className="hover:text-white" to="/cookie-policy">Cookie Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Contact</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            {s.address && (
              <li className="flex gap-2"><MapPin className="h-4 w-4 shrink-0 text-[#00E676]" />{s.address}</li>
            )}
            <li className="flex gap-2"><MapPin className="h-4 w-4 shrink-0 text-[#00E676]" />{s.service_area || "Greater Manchester"}</li>
            {s.email && (
              <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0 text-[#00E676]" />{s.email}</li>
            )}
            {s.phone && (
              <li className="flex gap-2"><Phone className="h-4 w-4 shrink-0 text-[#00E676]" />{s.phone}</li>
            )}
            <li className="flex gap-2"><Clock className="h-4 w-4 shrink-0 text-[#00E676]" />{s.opening_hours || "Mon–Sat 9am–7pm"}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-2 py-6 text-xs text-zinc-500 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {s.business_name || "EazyCarTrack PHV Private Hire Rental"}{s.company_number ? ` · Company No. ${s.company_number}` : ""}. All rights reserved.</p>
          <p className="max-w-2xl">
            EazyCarTrack PHV Private Hire Rental is an independent vehicle rental business. Not affiliated with Manchester City Council, Uber, Bolt or any operator, insurer or authority.
          </p>
        </div>
      </div>
    </footer>
  );
}
